import { calendarEventApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CALENDAR_EVENTS_ACTION_TYPE = createNamedActions('calendarEvents', {
  GET_CALENDAR_EVENTS: 'GET_CALENDAR_EVENTS',
  GET_CALENDAR_EVENTS_SUMMARY: 'GET_CALENDAR_EVENTS_SUMMARY',
  CREATE_CALENDAR_EVENT: 'CREATE_CALENDAR_EVENT',
  EDIT_CALENDAR_EVENT: 'EDIT_CALENDAR_EVENT',
  DELETE_CALENDAR_EVENT: 'DELETE_CALENDAR_EVENT',
});

const calendarEventSchema = new schema.Entity('data', {}, { idAttribute: 'calendarEventId' });

export const getAllManageableUsersCalendarEventsAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await calendarEventApi.getCalendarEventManageable(params);

    return dispatch({
      type: CALENDAR_EVENTS_ACTION_TYPE.GET_CALENDAR_EVENTS,
      payload: normalize(data, [calendarEventSchema]).entities.data,
    });
  },
);

export const getCalendarEventsByUserIdAction = catchAsyncActionError(
  ({ userId }) =>
    async dispatch => {
      const { data } = await calendarEventApi.getCalendarEvents({ userId });

      return dispatch({
        type: CALENDAR_EVENTS_ACTION_TYPE.GET_CALENDAR_EVENTS,
        payload: normalize(data, [calendarEventSchema]).entities.data,
      });
    },
);

export const getStateCalendarEventsSummaryAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await calendarEventApi.createCalendarEventSummary(params);

    return dispatch({
      type: CALENDAR_EVENTS_ACTION_TYPE.GET_CALENDAR_EVENTS_SUMMARY,
      payload: data,
    });
  },
);

export const createCalendarEventAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await calendarEventApi.createCalendarEvent(params);

  return dispatch({
    type: CALENDAR_EVENTS_ACTION_TYPE.CREATE_CALENDAR_EVENT,
    payload: data,
  });
});

export const editCalendarEventAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await calendarEventApi.editCalendarEvent(params);

  return dispatch({
    type: CALENDAR_EVENTS_ACTION_TYPE.EDIT_CALENDAR_EVENT,
    payload: data,
  });
});

export const deleteCalendarEventAction = catchAsyncActionError(params => async dispatch => {
  await calendarEventApi.deleteCalendarEvent(params);

  return dispatch({
    type: CALENDAR_EVENTS_ACTION_TYPE.DELETE_CALENDAR_EVENT,
    meta: params,
  });
});
